import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const ConditionalToggling = ({ condition, children }) => {
    if (condition) return <Fragment>{children}</Fragment>;

    return null;
};

ConditionalToggling.propTypes = {
    children: PropTypes.node.isRequired,
    condition: PropTypes.bool.isRequired,
};

export default ConditionalToggling;
